export const snowtypes_en = {
    "": "Not available",
    "altschnee": "Old snow",
    "corn_snow": "Corn Snow",
    "fine_granular": "Fine Granular",
    "frozen_granular": "Frozen Granular",
    "fruhlingsschnee": "Spring Snow",
    "powder_spring": "Powder-spring",
    "hard_pack": "Hard Pack",
    "hard_spring": "Hard-spring",
    "icy": "Icy",
    "kunstschnee": "Artificial snow",
    "looses_granular": "Looses Granular",
    "machine_groomed": "Machine groomed",
    "nassschnee": "Wet snow",
    "natural_snow": "Natural Snow",
    "neuschnee": "New snow",
    "packedpowder": "Packed powder",
    "pulverschnee": "Powder snow",
    "pulverschnee_nassschnee": "Powder-Humid",
    "powdertreaded": "Powder-flattened",
    "snowy_slopes_with_perfect_ski_conditions": "Perfect ski conditions",
    "sulz_harsch": "Hard snow",
    "variable_conditions": "Variable Conditions",
    "wet_granular": "Wet Granular",
    "wet_packed": "Wet Packed",
    "wind_blown": "Wind Blown",
}

export const snowtypes_de = {
    "": "Not available",
    "altschnee": "Alter Schnee",
    "corn_snow": "Firn",
    "fine_granular": "Feinkörnig",
    "frozen_granular": "Gefrorener, körniger Schnee",
    "fruhlingsschnee": "Frühling",
    "powder_spring": "Pulver-Feder",
    "hard_pack": "Hartschnee",
    "hard_spring": "Harter Firnschnee",
    "icy": "Eisig",
    "kunstschnee": "Künstlicher Schnee",
    "looses_granular": "Nass, körnig",
    "machine_groomed": "Präpariert",
    "nassschnee": "Nassschnee",
    "natural_snow": "Natürlicher Schnee",
    "neuschnee": "Neu",
    "packedpowder": "Eisiger Pulverschnee",
    "pulverschnee": "Pulverschnee",
    "pulverschnee_nassschnee": "Pulver-Nass",
    "powdertreaded": "Planierter Pulverschnee",
    "snowy_slopes_with_perfect_ski_conditions": "Perfekte Bedingungen",
    "sulz_harsch": "Eisig",
    "variable_conditions": "Variable Bedingungen",
    "wet_granular": "Nass",
    "wet_packed": "Nasser Hartschnee",
    "wind_blown": "Vom Wind zerfurcht",
}

export const snowtypes_fr = {
    "": "Not available",
    "altschnee": "Neige douce",
    "corn_snow": "Neige de Printemps",
    "fine_granular": "Granuleuse Fine",
    "frozen_granular": "Fraiche regelée",
    "fruhlingsschnee": "Neige de Printemps",
    "powder_spring": "Neige poudreuse de printemps",
    "hard_pack": "Compacte dure",
    "hard_spring": "Neige dure de printemps",
    "icy": "Regelée",
    "kunstschnee": "Neige artificielle",
    "looses_granular": "Humide regelée",
    "machine_groomed": "Fraisée",
    "nassschnee": "Humide",
    "natural_snow": "Neige naturelle",
    "neuschnee": "Fraîche",
    "packedpowder": "Poudreuse",
    "pulverschnee": "Poudreuse",
    "pulverschnee_nassschnee": "Poudreuse - Humide",
    "powdertreaded": "Neige poudreuse damée",
    "snowy_slopes_with_perfect_ski_conditions": "Conditions de ski parfaites",
    "sulz_harsch": "Neige dure",
    "variable_conditions": "Conditions variables",
    "wet_granular": "Humide",
    "wet_packed": "Compacte humide",
    "wind_blown": "Soufflée par le vent",
}

export const snowtypes_it = {
    "": "Not available",
    "altschnee": "Neve vecchia",
    "corn_snow": "Neve granulosa",
    "fine_granular": "Granulosa sottile",
    "frozen_granular": "Neve granulosa congelata",
    "fruhlingsschnee": "Neve primaverile",
    "powder_spring": "Primavera polvere",
    "hard_pack": "Neve compatta",
    "hard_spring": "Dura primavera",
    "icy": "Ghiacciato",
    "kunstschnee": "Neve artificiale",
    "looses_granular": "Neve granulosa umida",
    "machine_groomed": "Preparata a macchina",
    "nassschnee": "Neve umida",
    "natural_snow": "Neve naturale",
    "neuschnee": "Neve fresca",
    "packedpowder": "Neve battuta",
    "pulverschnee": "Neve polverosa",
    "pulverschnee_nassschnee": "Polvere-umido",
    "powdertreaded": "Neve spianata",
    "snowy_slopes_with_perfect_ski_conditions": "Condizioni sciistiche perfette",
    "sulz_harsch": "Neve compatta",
    "variable_conditions": "Condizioni variabili",
    "wet_granular": "Neve granulosa umida",
    "wet_packed": "Neve compatta umida",
    "wind_blown": "Ventoso",
}

export const snowtypes_es = {
    "": "No disponible",
    "altschnee": "Pisada",
    "corn_snow": "Nieve primavera",
    "fine_granular": "Granulada fina",
    "frozen_granular": "Granulada helada",
    "fruhlingsschnee": "Primavera",
    "powder_spring": "Primavera polvo",
    "hard_pack": "Compacta dura",
    "hard_spring": "Dura-primavera",
    "icy": "Helada",
    "kunstschnee": "Nieve artificial",
    "looses_granular": "Granulada húmeda",
    "machine_groomed": "Fresada",
    "nassschnee": "Nieve húmeda",
    "natural_snow": "Nieve natural",
    "neuschnee": "Reciente",
    "packedpowder": "Polvo dura",
    "pulverschnee": "Nieve polvo",
    "pulverschnee_nassschnee": "Polvo-Húmeda",
    "powdertreaded": "Polvo-pisada",
    "snowy_slopes_with_perfect_ski_conditions": "Condiciones perfectas",
    "sulz_harsch": "Dura",
    "variable_conditions": "Condiciones variables",
    "wet_granular": "Húmeda",
    "wet_packed": "Compacta húmeda",
    "wind_blown": "Soplada por el viento",
}

export const snowtypes_nb = {
    "": "Ikke tilgjengelig",
    "altschnee": "Gammel snø",
    "corn_snow": "Kornet snø",
    "fine_granular": "Finkornet snø",
    "frozen_granular": "Frosset kornsnø",
    "fruhlingsschnee": "Vår snø",
    "powder_spring": "Pulverfjær",
    "hard_pack": "Hardpakket",
    "hard_spring": "Vår",
    "icy": "Isete",
    "kunstschnee": "Kunstsnø",
    "looses_granular": "Frosset kornsnø",
    "machine_groomed": "Maskinpreparert",
    "nassschnee": "Våt snø",
    "natural_snow": "Natursnø",
    "neuschnee": "Nysnø",
    "packedpowder": "Kompakt nysnø",
    "pulverschnee": "Puddersnø",
    "pulverschnee_nassschnee": "Pudder- fuktig",
    "powdertreaded": "Oppkjørte løyper",
    "snowy_slopes_with_perfect_ski_conditions": "Perfekte forhold Perfekte ski forhold",
    "sulz_harsch": "Hardpakket snø",
    "variable_conditions": "Variable forhold",
    "wet_granular": "Våt",
    "wet_packed": "Kompakt fuktig",
    "wind_blown": "Blåst av vinden",
}
